<template>
	<div class="absolute bg-[#2E2E2E] rounded-md px-2 py-1 z-20">
		<p class="text-grays-400 text-sm font-medium">{{tooltipText}}</p>
		<!-- inlined so the arrow takes its colour from the same token as the
		     bubble - as an <img> it kept a hard coded fill of its own -->
		<svg
		class="absolute w-[19px] h-[11px] text-[#2E2E2E]"
		:class="[
			(positionBottom ? 'left-[10px] bottom-[-6.5px]' : ''),
			(positionLeft ? 'rotate-90 left-[-10.5px] top-0 bottom-0 m-auto' : ''),
			(positionRight ? 'rotate-[-90deg] right-[-10.5px] top-0 bottom-0 m-auto' : ''),
			(positionTop ? 'rotate-180 left-[10px] top-[-6.5px]' : ''),
		]"
		viewBox="0 0 16 9"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true">
			<path d="M8.36844 8.46939C8.06365 8.76502 7.57913 8.76502 7.27435 8.46939L0.70731 2.09971C0.200686 1.60831 0.548566 0.749999 1.25436 0.75L14.3884 0.750001C15.0942 0.750001 15.4421 1.60831 14.9355 2.09971L8.36844 8.46939Z" fill="currentColor"/>
		</svg>
	</div>
</template>

<script>
export default {
	name: "tooltip-small",
	props: {
		positionBottom: {
			type: Boolean,
			default: false,
		},
		positionLeft: {
			type: Boolean,
			default: false,
		},
		positionRight: {
			type: Boolean,
			default: false,
		},
		positionTop: {
			type: Boolean,
			default: false,
		},
		tooltipText: {
			type: String,
			default: "תיאור פעולת האייקון",
		}
	}
}
</script>

<style>

</style>
